<template>
  <md-card class="activity-card-wrapper">
    <a :aria-label="item.title + ' ' + item.nid"
       :href="'/node/' + item.nid"
    >
      <md-card-header :class="('color-' + item.field_color).toLowerCase()">
        <img v-if="item.uri" :src="item.uri" :alt="item.title"/>
      </md-card-header>
    </a>
    <md-card-content>
      <like-button
        :nid="item.nid"
        :show-counter="true"
        :default-counter="item.likes"
        :default-liked="item.liked"
      ></like-button>
      <div class="content-wrapper" @click="goTo('/node/' + item.nid)">
        <h2>{{ item.title }}</h2>
        <div v-if="item.field_aligned_competencies" class="competencies">
          Competency:
          <span v-html="item.field_aligned_competencies"></span>
        </div>
        <!-- <div class="description" v-html="item.body"></div> -->

        <div class="resource_type" v-if="item.field_resource_type">
          <div class="resource_type--inner"
               v-html="item.field_resource_type"
          >
          </div>
          <md-tooltip bmd-direction="bottom">
            {{ item.field_resource_type }}
          </md-tooltip>
        </div>

      </div>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "ActivityCard",
  props: ["item"],

  methods: {
    goTo(url) {
      window.location.href = url;
    },
  }
};
</script>

<style lang="scss">
.md-app-content .activity-card-wrapper {
  position: relative;

  .resource_type {
    position: absolute;
    top: -13px;
    padding: 4px 16px;
    border-radius: 20px 0 0 20px;
    right: 0;
    background-color: $blue-dark;
    font-size: 12px;
    line-height: 18px;
    font-weight: normal;
    text-transform: uppercase;
    color: #ffffff;
    max-width: 100%;

    .resource_type--inner {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 100%;
    }

    a {
      color: #ffffff;
    }
  }

  .like-button-wrapper {
    position: absolute;
    right: 0;
    top: 5px;
    color: rgba(60, 60, 60, 0.7);

    .md-button {
      color: #f64536;
      min-width: initial;
      height: auto;
    }

    .md-button-content {
      display: flex;
      flex-direction: column;
      min-height: 42px;

      span {
        padding: 0 !important;
        color: rgba(60, 60, 60, 0.7) !important;
        font-weight: normal;
      }

      .md-icon {
        color: #f64536;
      }
    }
  }

  &.md-card {
    color: rgba(60, 60, 60, 0.7);
    background-color: $white;
    overflow: hidden;
    transition: $transition;

    &:hover {
      transform: scale(1.01);

      .md-card-header {
        img {
          transform: scale(1.1);
        }

        svg {
          transform: scale(1.1);
        }
      }
    }

    @media all and (min-width: $breakpoint-medium) {
      width: calc(50% - 16px);
      margin: 0 8px 16px;
    }

    .md-card-header {
      border-radius: 20px 20px 0 0;
      margin-bottom: 0;
      min-height: 131px;

      img {
        transition: $transition;
        max-height: 90px;
        min-height: 90px;
        min-width: 90px;
      }

      svg {
        max-height: 90px;
        min-height: 90px;
        min-width: 90px;
        transition: $transition;
      }

      & > img {
        float: none;
        border-radius: 0;
        transition: $transition;
      }

      text-align: center;
      background-color: $orange;

      &.color-orange {
        background-color: $orange;
      }

      &.color-yellow {
        background-color: $yellow;
      }

      &.color-blue {
        background-color: $blue;
      }

      &.color-green {
        background-color: $green;
      }
    }

    .md-card-content {
      position: relative;
      padding: 0;

      p {
        margin: 0;
      }
    }

    .content-wrapper {
      cursor: pointer;
      padding: 16px 24px;
      text-align: left;
    }

    a {
      color: rgb(60, 60, 60);

      &:hover {
        color: rgb(60, 60, 60);
      }

      font-family: $font-filson-soft;
    }

    h2 {
      color: $blue-dark;
      font-family: $font-filson-soft;
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      margin: 0 0 8px 0;
      @media all and (max-width: $breakpoint-xsmall) {
        margin: 0 25px 20px 0;
      }
    }
  }
}
</style>
